export const getCookie = (cname) => {
  const name = cname + "="
  const decodedCookie = decodeURIComponent(document.cookie)
  const ca = decodedCookie.split(';')
  for(let i = 0; i <ca.length; i++) {
    let c = ca[i]
    while (c.charAt(0) == ' ') {
      c = c.substring(1)
    }
    if (c.indexOf(name) == 0) {
      return c.substring(name.length, c.length)
    }
  }
  return ""
}

export const setCookie = (cname, cvalue, exdays) => {
  const d = new Date()
  d.setTime(d.getTime() + (exdays*24*60*60*1000))
  const expires = "expires="+ d.toUTCString()
  document.cookie = cname + "=" + cvalue + ";" + expires + ";path=/"
}

export const deleteCookie = (name) => setCookie(name, '', -1)

export const setCookieHelper = (variable, value, expires_seconds) => {
  let d = new Date()
  d = new Date(d.getTime() + 1000 * expires_seconds)
  document.cookie = `${variable}=${value}; expires=${d.toUTCString()};path=/`
}
